import { Col } from './Col';
import { Row } from './Row';

export class ResultsTable {

  cols: Array<Col>;
  rows: Array<Row>;

  constructor(cols: Array<Col>, rows: Array<Row>) {
    this.cols = cols;
    this.rows = rows;
  }

}
